require('js/main/ga-tracking.js');
require('js/main/star.js');
require('js/main/navbar.js');
require('sass/main-2015/main.scss');

var b = document.getElementsByClassName('sponsor-button')[0];

b.onclick = function() {
  this.innerHTML = "sponsor@hackthenorth.com";
  ga('send', 'event', 'button', 'click', 'sponsor-email');
}

var applyButton = document.getElementById('htn-apply');
applyButton.onclick = apply;
var loginButton = document.getElementById('htn-login');
loginButton.onclick = login;


function unixTimeStamp() {
  return Math.round(new Date().getTime()/1000);
}

function register() {
  ga('send', 'event', 'button', 'click', 'apply-mailing-list');
  var user_email = document.getElementById('email').value;
  var url = 'https://htn.firebaseio.com/signups.json';
  var payload = {email: user_email.toString(), time: unixTimeStamp()};
  if (user_email.length > 0) {
    var oReq = new XMLHttpRequest();
    oReq.onreadystatechange = function() {
      if (oReq.readyState == 4 && oReq.status === 200) {
        var response = JSON.parse(oReq.responseText);
        var $error = document.getElementById('error');
        var $confirmation = document.getElementById('confirmation');
        if ('error' in response) {
          $error.style.display = 'block';
        }
        else {
          $error.style.display = 'none';
          $confirmation.style.display = 'block';
          document.getElementById('email').value = '';
        }
      }
    }
    var data = JSON.stringify(payload);
    oReq.open("POST", url, true);
    oReq.setRequestHeader("Content-type", "application/json");
    oReq.setRequestHeader("Content-length", data.length);
    oReq.setRequestHeader("Connection", "close");
    oReq.send(data);

    hackerApiCall(user_email)
  }
}

function apply(e) {
  e.preventDefault();
  ga('send', 'event', '2015_registration', 'click', '2015_registration-apply-landing-page');
  window.location = window.location.origin + '/judging';
}

function login(e) {
  e.preventDefault();
  ga('send', 'event', '2015_registration', 'click', '2015_registration-login-landing-page');
  window.location = window.location.origin + '/application';
}

function judging(e) {
  e.preventDefault();
  ga('send', 'event', '2015_judging', 'click', '2015_judging-landing-page');
  window.location = window.location.origin + '/judging';
}

function hackerApiCall(email){
  var url = 'https://hackerapi.com/v1/events/hackthenorth/signups';
  var payload = JSON.stringify({ email: email.toString() });
  var req = new XMLHttpRequest();
  req.onreadystatechange = function() {
    if (req.readyState == 4 && req.status === 200) {
      var response = JSON.parse(req.responseText);
    }
  }
  req.open("POST", url, true);
  req.setRequestHeader("Content-type", "application/json");
  req.send(payload);
}



/*****************
 ** WEBPACK FOOTER
 ** ./js/main/main-2015.js
 ** module id = 385
 ** module chunks = 4
 **/